import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import CarCrashOutlinedIcon from '@mui/icons-material/CarCrashOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon']): NavItem => ({ label, path, icon, module: Modules.Fleet, permission: Perm.Fleet.View });

/**
 * The fleet module's navigation: one Fleet menu, grown phase by phase (trips, fuel, workshop and
 * costs join the vehicles). Shown only where the organisation has the module on.
 */
export const fleetNavEntries: NavEntry[] = [
  item('Overview', '/fleet', DashboardOutlinedIcon),
  item('Vehicles', '/fleet/vehicles', DirectionsCarOutlinedIcon),
  item('Acquisition', '/fleet/acquisition', ShoppingCartOutlinedIcon),
  item('Trips', '/fleet/trips', RouteOutlinedIcon),
  item('Fuel', '/fleet/fuel', LocalGasStationOutlinedIcon),
  item('Workshop', '/fleet/workshop', BuildOutlinedIcon),
  item('Fleet Costs', '/fleet/costs', PaidOutlinedIcon),
  item('Inspections', '/fleet/inspections', FactCheckOutlinedIcon),
  item('Incidents', '/fleet/incidents', CarCrashOutlinedIcon),
  item('Fleet Use', '/fleet/usage', InsightsOutlinedIcon),
  item('Bookings and Planning', '/fleet/planning', EventAvailableOutlinedIcon),
  item('Drivers', '/fleet/drivers', BadgeOutlinedIcon),
  item('Exceptions', '/fleet/exceptions', ReportProblemOutlinedIcon),
  item('Fleet Settings', '/fleet/settings', SettingsOutlinedIcon),
];

export const fleetNavGroup: NavGroup = {
  kind: 'group', key: 'fleet', label: 'Fleet', icon: LocalShippingOutlinedIcon, items: fleetNavEntries,
};
